import { default as classnames } from 'classnames';
import { format as dateFormat } from 'date-fns';
import { BaseCard } from '~/components/Card';
import { ChallengeScoreUpHistory } from '~/components/Challenge/Score/ChallengeScore.hooks';
import { T } from '~/components/I18n';
import gem from '~/components/Icon/gem.png';
import { DescriptionList } from '~/components/List/Description/DescriptionList';
import { format, formatDon } from '~/components/Util/number';
import styles from './ChallengeScoreUpItem.module.scss';

export type ChallengeScoreUpItemProps = {
  className?: string;
} & ChallengeScoreUpHistory;

export const ChallengeScoreUpItem = ({ className, ...props }: ChallengeScoreUpItemProps) => {
  const { participatedAt, scoreUpScore, joinForAssetAmount, assetType, count } = props;
  return (
    <BaseCard className={classnames(styles.root, className)} size="large">
      <div className={styles.header}>
        <p className={styles.time}>{dateFormat(participatedAt, 'PP p')}</p>
      </div>
      <div className={styles.aside}>
        <img src={gem} alt="Score Up" className={styles.image} width={36} height={36} />
      </div>
      <div className={styles.body}>
        <p className={styles.description}>
          <T name="citizen_challenge_scoreup_name" />
          <svg
            width="10"
            height="11"
            viewBox="0 0 10 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={styles.cross}>
            <path d="M9 1.5L1 9.5M9 9.5L1 1.5" stroke="black" strokeWidth="1.5" />
          </svg>{' '}
          <T name="citizen_unit" options={{ 0: count, count }} />
        </p>
        <p className={styles.don}>
          <strong>
            {formatDon(joinForAssetAmount)} {assetType}
          </strong>
        </p>
      </div>
      <div className={styles.footer}>
        <hr className={styles.hr} />
        <DescriptionList layout="horizontal" className={styles.descriptionList}>
          <dt>
            <T name="citizen_challenge_history_scoreup_result" />
          </dt>
          <dd>
            <T name="citizen_unit_score" options={[format(scoreUpScore)]} />
          </dd>
        </DescriptionList>
      </div>
    </BaseCard>
  );
};
